import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer 
      className="bg-[#1F2933] text-white"
      data-testid="footer"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div>
            <p className="text-lg font-semibold mb-2">MJV Holdings</p>
            <p className="text-[#9CA3AF] text-sm leading-relaxed">
              Building practical digital companies for everyday people.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-sm font-medium text-[#9CA3AF] mb-3">Navigation</p>
            <div className="flex flex-col gap-2">
              <Link 
                to="/" 
                className="text-sm text-white/80 hover:text-white transition-colors w-fit"
                data-testid="footer-link-home"
              >
                Home
              </Link>
              <Link 
                to="/portfolio" 
                className="text-sm text-white/80 hover:text-white transition-colors w-fit"
                data-testid="footer-link-portfolio"
              >
                Portfolio
              </Link>
              <Link 
                to="/about" 
                className="text-sm text-white/80 hover:text-white transition-colors w-fit"
                data-testid="footer-link-about"
              >
                About
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="text-sm font-medium text-[#9CA3AF] mb-3">Contact</p>
            <a 
              href="mailto:hello@mjvholdings.com"
              className="text-sm text-white/80 hover:text-white transition-colors"
              data-testid="footer-email-link"
            >
              hello@mjvholdings.com
            </a>
            <p className="text-sm text-[#6B7280] mt-2">Atlanta, Georgia</p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-[#374151]">
          <p className="text-sm text-[#6B7280]" data-testid="footer-copyright">
            © 2026 MJV Holdings. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
